import { useState } from 'react';

import {
  Button,
  ListContainer,
  ListItem,
  SearchBar,
  Typography,
} from '@altify/components';
import { content } from './SelectionCategoryModal.content';
// Misc
import {
  useContent,
} from '@altify/utils';
import { DialogOrBottomSheet } from 'components/DialogOrBottomSheet/DialogOrBottomSheet';
import clsx from 'clsx';
const supportEmail = 'support@altify.app';

const SelectionCategoryModal = ({
  isOpen,
  onClose,
  onSelect,
  categories
}: {
  isOpen: boolean;
  onClose?: () => void;
  onSelect?: (category: string ) => void;
  categories: { value: string; label: string; selectedLabel: string; className: string, textClassName: string; icon?: any; }[];
}) => {

  const localizedContent = useContent(content);

  const [search, setSearch] = useState(false);
  const [searchQuery, setSearchQuery] = useState<string>('');


  function reset() {
    setSearch(false);
    setSearchQuery('');
  }

  function handleSelect(category: string) {
    reset();
    onSelect?.(category)
    onClose?.();
  }  
  
  const noResultsFound =
    categories.filter(
      pr =>
        pr.label.toLowerCase().includes(searchQuery.toLowerCase()) ||
        pr.value.toLowerCase().includes(searchQuery.toLowerCase()),
    ).length === 0;

  return (
    <DialogOrBottomSheet
      isOpen={isOpen}
      blurEnabled={true}
      onClose={() => {
        reset();
        onClose?.();
      }}
      initialSnapPosition={1}
      detent='full-height'
      backgroundColor="#0C1C2C">
      <div className="items-center px-4 h-full mt-4">
        <div className="flex flex-row w-full items-center">
          <SearchBar
            className="flex-1"
            value={searchQuery}
            onValueChanged={e => {
              setSearchQuery(e ?? '');
            }}
            onFocus={() => {
              setSearch(true);
            }}
            onBlur={() => {
              setSearch(false);
            }}
          />
          
          <Button
            onPress={() => {
              setSearchQuery('');
              reset();
              onClose?.();
            }}
            fullWidth={false}
            color="transparent"
            size="large"
            className='mt-1'
            text={localizedContent.cancel}
          />
        </div>
        {searchQuery && noResultsFound && (
          <div className="flex-row mt-6 w-full">
            <div className="flex flex-col items-start mt-6 w-full">
              <Typography className="text-error mb-4" size="medium" weight='medium'>
                {localizedContent.noResults}
              </Typography>
              
              <a href={`mailto:${supportEmail}`} className='flex flex-row flex-wrap'>
                <Typography size="medium">
                  {localizedContent.suggestNewAsset}
                  <Typography weight='bold'>{' ' + supportEmail}</Typography>
                </Typography>
                
              </a>
            </div>
          </div>
        )}
        <div className="mt-6">
        <div className="w-full mb-4">
            {(
              <>
              {!noResultsFound ?
                <>
                {searchQuery  ?
                  <Typography size='medium' weight='medium' className="text-left flex-1 mb-4 text-gray-400">
                    {localizedContent.searchResults}
                  </Typography>
                :
                  <Typography size='medium' weight='medium' className="text-left flex-1 mb-4 text-gray-400">
                    {localizedContent.productTypes}
                  </Typography>
                }
                </>
              : null}
              {categories &&
                <ListContainer>
                  {(categories as (typeof categories))!.filter(
                        cat =>
                          cat.label.toLowerCase().includes(searchQuery.toLowerCase()) ||
                          cat.value.toLowerCase().includes(searchQuery.toLowerCase()),
                      )!.map(item => (
                  <ListItem onPress={() => handleSelect(item.value)} pressable={true}>
                    <div className="w-full ">
                      <div className="flex flex-row gap-2 justify-center items-center">
                        <div className={clsx('border-0 rounded-full', item.className)}>
                          {item?.icon && item.icon()}
                        </div>
                        <div className="flex-1 flex-column justify-center">
                          <Typography weight="medium" size="large" className={clsx('py-0 text-white')}>
                            {item.label ?? ''}
                          </Typography>
                        </div>
                      </div>
                    </div>
                  </ListItem>
                  ),
                )}
                  
                </ListContainer>
                }
              </>
            )}
          </div>
        </div>
      </div>
      
    </DialogOrBottomSheet>
  );
};

export default SelectionCategoryModal;